import React from 'react';
import { Link } from 'react-router-dom';
import { CTAButton } from '../components/shared';
export function NotFound() {
  return <section className="mx-auto flex min-h-[70vh] max-w-3xl flex-col items-center justify-center px-4 pt-32 text-center" data-id="element-437">
      <p className="text-sm font-black uppercase tracking-[0.2em] text-sky-500" data-id="element-438">
        404
      </p>
      <h1 className="mt-4 text-5xl font-black tracking-tight" data-id="element-439">
        We couldn't find that page.
      </h1>
      <p className="mt-4 leading-8 text-slate-600" data-id="element-440">
        The page may have moved. Try jumping back to the homepage or get in
        touch with our team.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3" data-id="element-441">
        <CTAButton to="/" data-id="element-442">Back to home</CTAButton>
        <CTAButton variant="dark" to="/contact" data-id="element-443">
          Contact us
        </CTAButton>
      </div>
    </section>;
}